export const Logo = () => {
  return (
    <svg
      width="68"
      height="77"
      viewBox="0 0 68 77"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SHIDO - Logo + Text 1">
        <g id="Group">
          <g id="Group_2">
            <path
              id="Vector"
              d="M3.20312 38.5871L14.8416 45.3011V50.4634L33.992 61.5059L53.1788 50.4634V45.1198L64.81 38.4639V57.0541L33.992 74.8105L3.20312 57.0686V38.5871Z"
              fill="url(#paint0_linear_159_17)"
            />
            <path
              id="Vector_2"
              d="M14.8466 39.6963L3.22266 32.9969L3.23719 21.5339L23.4556 9.93311C23.4556 9.93311 22.1333 16.3208 28.5483 20.4535L14.8539 28.3566L14.8466 39.6963Z"
              fill="url(#paint1_linear_159_17)"
            />
            <path
              id="Vector_3"
              d="M39.3809 20.4609C39.3809 20.4609 45.4762 17.3214 44.4881 9.94043L64.7792 21.6282L64.7646 33.0332L53.177 39.6601L53.1625 28.4001L39.3809 20.4609Z"
              fill="url(#paint2_linear_159_17)"
            />
            <path
              id="Vector_4"
              d="M33.9194 43.1841L27.8168 46.6644L17.6895 40.8277V33.7803L33.9194 43.1841Z"
              fill="url(#paint3_linear_159_17)"
            />
            <path
              id="Vector_5"
              d="M34.0566 43.1768L40.1519 46.657L50.2793 40.8204V33.7729L34.0566 43.1768Z"
              fill="url(#paint4_linear_159_17)"
            />
            <path
              id="Vector_6"
              d="M33.9779 20.4102C38.9773 20.4102 43.0301 16.3493 43.0301 11.3399C43.0301 6.33046 38.9773 2.26953 33.9779 2.26953C28.9786 2.26953 24.9258 6.33046 24.9258 11.3399C24.9258 16.3493 28.9786 20.4102 33.9779 20.4102Z"
              fill="url(#paint5_linear_159_17)"
            />
          </g>
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_159_17"
          x1="32.7974"
          y1="-4.6595"
          x2="34.4217"
          y2="66.1368"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A6FF" />
          <stop offset="1" stopColor="#0068FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_159_17"
          x1="15.1738"
          y1="-4.25538"
          x2="16.798"
          y2="66.5409"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A6FF" />
          <stop offset="1" stopColor="#0068FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_159_17"
          x1="51.4797"
          y1="-5.08824"
          x2="53.104"
          y2="65.708"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A6FF" />
          <stop offset="1" stopColor="#0068FF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_159_17"
          x1="24.7325"
          y1="-4.47425"
          x2="26.3567"
          y2="66.322"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A6FF" />
          <stop offset="1" stopColor="#0068FF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_159_17"
          x1="41.1718"
          y1="-4.85152"
          x2="42.796"
          y2="65.9447"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A6FF" />
          <stop offset="1" stopColor="#0068FF" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_159_17"
          x1="33.6096"
          y1="-4.67811"
          x2="35.2338"
          y2="66.1181"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A6FF" />
          <stop offset="1" stopColor="#0068FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const Searchicon = () => {
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Group">
        <path
          id="Vector"
          d="M7.63824 15.3436C9.32804 15.3436 10.9695 14.7788 12.3027 13.7385L17.3322 18.7774C17.7079 19.1409 18.3066 19.1305 18.6695 18.754C19.0234 18.3869 19.0234 17.8047 18.6695 17.4376L13.64 12.3987C16.2166 9.0758 15.6166 4.28939 12.2998 1.708C8.98297 -0.873394 4.20547 -0.272277 1.62886 3.05067C-0.947753 6.37362 -0.34775 11.16 2.96905 13.7414C4.30437 14.7807 5.94733 15.3445 7.63824 15.3436ZM3.59707 3.67695C5.82897 1.44087 9.44759 1.44083 11.6795 3.67687C13.9115 5.9129 13.9115 9.53824 11.6796 11.7743C9.44771 14.0104 5.82909 14.0104 3.59715 11.7744L3.59707 11.7743C1.36517 9.55457 1.35202 5.94245 3.56766 3.70641L3.59707 3.67695Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export const ThreeLine = () => {
  return (
    <svg
      width="14"
      height="10"
      viewBox="0 0 14 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.76742 5.78964H11.2824V4.37011H2.76742M0.638672 0.821289V2.24082H13.4112V0.821289M5.60576 9.33847H8.44409V7.91894H5.60576V9.33847Z"
        fill="#AFB7C0"
      />
    </svg>
  );
};
export const InfoIcon = () => {
  return (
    <svg
      width="35"
      height="36"
      viewBox="0 0 35 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.2883 0.469727C21.8139 0.469727 26.1541 2.3136 29.3542 5.59572C32.5543 8.87785 34.352 13.3294 34.352 17.971C34.352 22.6126 32.5543 27.0641 29.3542 30.3462C26.1541 33.6283 21.8139 35.4722 17.2883 35.4722C12.7627 35.4722 8.42252 33.6283 5.22246 30.3462C2.02239 27.0641 0.224609 22.6126 0.224609 17.971C0.224609 13.3294 2.02239 8.87785 5.22246 5.59572C8.42252 2.3136 12.7627 0.469727 17.2883 0.469727ZM19.8477 11.2147C21.1152 11.2147 22.1438 10.3122 22.1438 8.97473C22.1438 7.63723 21.1128 6.73473 19.8477 6.73473C18.5802 6.73473 17.5565 7.63723 17.5565 8.97473C17.5565 10.3122 18.5802 11.2147 19.8477 11.2147ZM20.2938 25.2822C20.2938 25.0147 20.384 24.3197 20.3328 23.9247L18.3291 26.2897C17.9148 26.7372 17.3956 27.0472 17.1518 26.9647C17.0412 26.923 16.9488 26.8421 16.8912 26.7367C16.8335 26.6313 16.8144 26.5083 16.8374 26.3897L20.1768 15.5697C20.4498 14.1972 19.699 12.9447 18.1073 12.7847C16.4279 12.7847 13.9563 14.5322 12.4523 16.7497C12.4523 17.0147 12.4036 17.6747 12.4548 18.0697L14.456 15.7022C14.8703 15.2597 15.353 14.9472 15.5967 15.0322C15.7168 15.0764 15.8152 15.1672 15.8708 15.285C15.9264 15.4027 15.9348 15.5382 15.8941 15.6622L12.584 26.4297C12.2013 27.6897 12.9252 28.9247 14.6802 29.2047C17.264 29.2047 18.7898 27.4997 20.2962 25.2822H20.2938Z"
        fill="#FFDA16"
      />
    </svg>
  );
};
export const Vooting = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3131_241)">
        <path
          opacity="0.5"
          d="M8.62172 14.4827C10.3251 14.4827 11.9587 13.806 13.1631 12.6016C14.3676 11.3971 15.0442 9.76355 15.0442 8.0602C15.0442 6.35684 14.3676 4.72325 13.1631 3.5188C11.9587 2.31435 10.3251 1.6377 8.62172 1.6377C6.91837 1.6377 5.28478 2.31435 4.08033 3.5188C2.87587 4.72325 2.19922 6.35684 2.19922 8.0602C2.19922 9.76355 2.87587 11.3971 4.08033 12.6016C5.28478 13.806 6.91837 14.4827 8.62172 14.4827Z"
          stroke="#E2A850"
          strokeWidth="2.69922"
        />
        <path
          d="M15.0436 8.06006C15.0436 9.76341 14.3669 11.397 13.1625 12.6015C11.958 13.8059 10.3244 14.4826 8.62109 14.4826"
          stroke="#E2A850"
          strokeWidth="2.69922"
        />
        <path
          d="M8.62117 11.7301C9.59452 11.7301 10.528 11.3435 11.2163 10.6552C11.9045 9.96696 12.2912 9.03348 12.2912 8.06014C12.2912 7.08679 11.9045 6.15331 11.2163 5.46505C10.528 4.7768 9.59452 4.39014 8.62117 4.39014C7.64783 4.39014 6.71435 4.7768 6.02609 5.46505C5.33783 6.15331 4.95117 7.08679 4.95117 8.06014C4.95117 9.03348 5.33783 9.96696 6.02609 10.6552C6.71435 11.3435 7.64783 11.7301 8.62117 11.7301Z"
          fill="#E2A850"
        />
      </g>
      <defs>
        <clipPath id="clip0_3131_241">
          <rect
            x="0.378906"
            y="0.0302734"
            width="16.04"
            height="16.04"
            rx="8.02"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const Translation = () => {
  return (
    <svg
      width="14"
      height="12"
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.38532 8.03836L5.94917 6.62021L5.96613 6.60326C6.94995 5.50716 7.65107 4.24721 8.06382 2.91381H9.72049V1.78381H5.76258V0.653809H4.63174V1.78381H0.673828V2.91381H6.98953C6.6107 3.99861 6.01136 5.03256 5.19716 5.93656C4.67132 5.35461 4.23595 4.71616 3.89105 4.04381H2.76022C3.17297 4.96476 3.73839 5.83486 4.44516 6.62021L1.56719 9.45651L2.37008 10.2588L5.19716 7.43381L6.95561 9.19096L7.38532 8.03836ZM10.5686 5.17381H9.43779L6.89341 11.9538H8.02424L8.65751 10.2588H11.3432L11.9822 11.9538H13.113L10.5686 5.17381ZM9.08723 9.12881L10.0032 6.68236L10.9192 9.12881H9.08723Z"
        fill="#FFC533"
      />
    </svg>
  );
};

export const Cosmos = () => {
  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.0007 0.0834961C10.2923 0.0834961 0.0839844 10.2918 0.0839844 23.0002C0.0839844 35.7085 10.2923 45.9168 23.0007 45.9168C35.709 45.9168 45.9173 35.7085 45.9173 23.0002C45.9173 10.2918 35.709 0.0834961 23.0007 0.0834961ZM34.8757 30.5002C34.459 30.9168 34.0423 31.1252 33.209 31.1252C31.5423 31.1252 29.0423 30.0835 26.334 28.8335C25.9173 33.0002 24.8757 36.9585 23.0007 36.9585C21.959 36.9585 21.1257 35.5002 20.5007 33.2085C19.8757 33.0002 19.459 32.5835 19.459 31.9585C19.459 31.5418 19.6673 31.1252 20.084 30.9168C19.8757 30.2918 19.8757 29.4585 19.8757 28.8335C17.1673 30.2918 14.459 31.3335 12.7923 31.3335C11.959 31.3335 11.334 31.1252 11.1257 30.7085C10.084 29.0418 13.209 25.9168 16.7507 23.2085C15.9173 22.5835 14.8757 21.7502 14.2507 21.1252C14.0423 21.1252 14.0423 21.1252 13.834 21.1252C13.209 21.1252 12.584 20.5002 12.584 19.8752C12.584 19.6668 12.584 19.4585 12.7923 19.2502C11.7507 18.2085 11.1257 17.1668 11.1257 16.3335C11.1257 16.1252 11.1257 15.9168 11.334 15.7085C12.3757 14.2502 16.1257 15.2918 19.8757 17.1668C20.2923 13.0002 21.334 9.04183 23.209 9.04183C25.084 9.04183 26.1257 12.7918 26.5423 17.1668C27.3757 16.7502 28.209 16.3335 29.0423 16.1252C29.0423 15.5002 29.6673 14.8752 30.2923 14.8752C30.709 14.8752 30.9173 15.0835 31.334 15.2918C32.7923 14.6668 34.2507 14.6668 34.8757 15.5002C35.9173 17.1668 32.7923 20.2918 29.2507 23.0002C32.7923 25.7085 35.9173 28.8335 34.8757 30.5002Z"
        fill="#8B8BA8"
      />
    </svg>
  );
};
export const CopyIcon = () => {
  return (
    <svg
      width="11"
      height="12"
      viewBox="0 0 11 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.47854 10.692H3.59812V3.20759H9.47854M9.47854 2.1384H3.59812C3.31456 2.1384 3.04262 2.25104 2.84211 2.45156C2.6416 2.65207 2.52896 2.92402 2.52896 3.20759V10.692C2.52896 10.9755 2.6416 11.2475 2.84211 11.448C3.04262 11.6485 3.31456 11.7612 3.59812 11.7612H9.47854C9.7621 11.7612 10.034 11.6485 10.2346 11.448C10.4351 11.2475 10.5477 10.9755 10.5477 10.692V3.20759C10.5477 2.92402 10.4351 2.65207 10.2346 2.45156C10.034 2.25104 9.7621 2.1384 9.47854 2.1384ZM7.87479 0H1.45979C1.17623 0 0.904284 0.112647 0.703777 0.313161C0.503269 0.513674 0.390625 0.785629 0.390625 1.0692V8.55358H1.45979V1.0692H7.87479V0Z"
        fill="#0086FF"
      />
    </svg>
  );
};
export const RightArrow = () => {
  return (
    <svg
      width="6"
      height="10"
      viewBox="0 0 6 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.3108e-08 8.90079L3.57829 5.3225L9.84493e-08 1.74421L1.10701 0.645L5.78451 5.3225L1.10701 10L1.3108e-08 8.90079Z"
        fill="#AFB7C0"
      />
    </svg>
  );
};
export function CloseIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      viewBox="0 0 16 18"
      fill="none"
    >
      <path
        d="M2.27517 17.355C1.90346 17.3797 1.53788 17.2382 1.25552 16.9602C0.698681 16.3187 0.698681 15.2827 1.25552 14.6411L13.4484 0.677219C14.0276 0.0565654 14.9364 0.0910672 15.4783 0.754348C15.9684 1.35415 15.997 2.27606 15.5452 2.9141L3.28045 16.9602C3.00176 17.2342 2.64201 17.3755 2.27517 17.355Z"
        fill="white"
      />
      <path
        d="M14.4538 17.3552C14.077 17.3534 13.716 17.1821 13.4484 16.8783L1.25549 2.9143C0.739605 2.22438 0.809742 1.18607 1.41217 0.595205C1.94985 0.0678742 2.74283 0.0678742 3.28047 0.595205L15.5452 14.5591C16.1242 15.18 16.1542 16.2208 15.6121 16.8839C15.5905 16.9103 15.5682 16.9358 15.5452 16.9605C15.3966 17.1085 15.2231 17.2199 15.0353 17.2878C14.8476 17.3557 14.6496 17.3786 14.4538 17.3552Z"
        fill="white"
      />
    </svg>
  );
}
export const Uparrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12.818"
      height="11.99"
      viewBox="0 0 12.818 11.99"
    >
      <g
        id="Icon_feather-arrow-up"
        data-name="Icon feather-arrow-up"
        transform="translate(1.414 1)"
      >
        <path
          id="Path_3"
          data-name="Path 3"
          d="M18,7.5v9.99"
          transform="translate(-13.005 -7.5)"
          fill="none"
          stroke="#014cec"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          id="Path_4"
          data-name="Path 4"
          d="M7.5,7.5l4.995,4.995L17.49,7.5"
          transform="translate(-7.5 -2.505)"
          fill="none"
          stroke="#014cec"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
};
export const Facebook = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="facebook">
        <path
          id="Vector (Stroke)"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.2275 5.21206C17.7283 5.21212 17.2341 5.31111 16.7734 5.50332C16.3127 5.69554 15.8946 5.97718 15.5434 6.33196C15.1922 6.68674 14.9148 7.10761 14.7273 7.57025C14.5397 8.03289 14.4457 8.52812 14.4508 9.02731L14.4591 9.87089L14.4591 9.90047L14.3986 14.5425C14.3894 15.2475 13.8153 15.8142 13.1103 15.8142H9.79458V18.1286H13.1708C13.8824 18.1286 14.4592 18.7054 14.4592 19.417V27.1011H17.5327V19.417C17.5327 18.7054 18.1095 18.1286 18.8211 18.1286H22.1003L22.4565 15.8142H18.8205C18.1089 15.8142 17.5321 15.2373 17.5321 14.5257V10.0833C17.5321 8.67142 18.6766 7.52843 20.0869 7.52843H22.6699V5.21206H18.2275C18.2275 5.21206 18.2275 5.21206 18.2275 5.21206ZM15.7812 3.1252C16.5562 2.80184 17.3876 2.63532 18.2274 2.63525H23.9583C24.6699 2.63525 25.2467 3.21209 25.2467 3.92366V8.81683C25.2467 9.5284 24.6699 10.1052 23.9583 10.1052H20.1089V13.2373H23.9583C24.3342 13.2373 24.6914 13.4015 24.9362 13.6868C25.1809 13.9722 25.2889 14.3501 25.2317 14.7217L24.4791 19.6129C24.3824 20.2414 23.8416 20.7054 23.2057 20.7054H20.1095V28.3895C20.1095 29.1011 19.5327 29.6779 18.8211 29.6779H13.1708C12.4592 29.6779 11.8824 29.1011 11.8824 28.3895V20.7054H8.50618C7.79461 20.7054 7.21777 20.1286 7.21777 19.417V14.5257C7.21777 13.8142 7.79461 13.2373 8.50618 13.2373H11.8386L11.8823 9.88165L11.8741 9.05318C11.8741 9.05313 11.8741 9.05323 11.8741 9.05318C11.8657 8.21351 12.0238 7.38035 12.3392 6.60215C12.6547 5.82391 13.1214 5.11592 13.7122 4.51912C14.303 3.92232 15.0062 3.44855 15.7812 3.1252Z"
          fill="white"
        />
      </g>
    </svg>
  );
};
export const Instagram = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="instagram">
        <path
          id="shape"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.5286 2.86353C12.9186 2.86353 12.4659 2.87883 11.0482 2.94351C9.63338 3.00804 8.66713 3.23276 7.82164 3.56138C6.94756 3.90102 6.20628 4.35552 5.46728 5.09448C4.72832 5.83348 4.27382 6.57476 3.93418 7.44884C3.60557 8.29432 3.38085 9.26058 3.31632 10.6754C3.25163 12.0931 3.23633 12.5458 3.23633 16.1558C3.23633 19.7657 3.25163 20.2184 3.31632 21.6361C3.38085 23.0509 3.60557 24.0172 3.93418 24.8627C4.27382 25.7367 4.72832 26.478 5.46728 27.217C6.20628 27.956 6.94756 28.4105 7.82164 28.7502C8.66713 29.0787 9.63338 29.3035 11.0482 29.368C12.4659 29.4327 12.9186 29.448 16.5286 29.448C20.1385 29.448 20.5912 29.4327 22.0089 29.368C23.4237 29.3035 24.39 29.0787 25.2355 28.7502C26.1096 28.4105 26.8508 27.956 27.5898 27.217C28.3288 26.478 28.7833 25.7367 29.123 24.8627C29.4515 24.0172 29.6763 23.0509 29.7408 21.6361C29.8055 20.2184 29.8208 19.7657 29.8208 16.1558C29.8208 12.5458 29.8055 12.0931 29.7408 10.6754C29.6763 9.26058 29.4515 8.29432 29.123 7.44884C28.7833 6.57476 28.3288 5.83348 27.5898 5.09448C26.8508 4.35552 26.1096 3.90102 25.2355 3.56138C24.39 3.23276 23.4237 3.00804 22.0089 2.94351C20.5912 2.87883 20.1385 2.86353 16.5286 2.86353ZM16.5296 5.25715C20.0787 5.25715 20.4991 5.27071 21.9007 5.33466C23.1967 5.39375 23.9005 5.61029 24.3689 5.79233C24.9894 6.03346 25.4322 6.32149 25.8973 6.78666C26.3624 7.25177 26.6505 7.69456 26.8916 8.31501C27.0736 8.78339 27.2902 9.4872 27.3493 10.7832C27.4132 12.1848 27.4268 12.6052 27.4268 16.1544C27.4268 19.7036 27.4132 20.124 27.3493 21.5256C27.2902 22.8216 27.0736 23.5254 26.8916 23.9938C26.6505 24.6142 26.3624 25.057 25.8973 25.5221C25.4322 25.9873 24.9894 26.2753 24.3689 26.5164C23.9005 26.6985 23.1967 26.915 21.9007 26.9741C20.4993 27.0381 20.079 27.0516 16.5296 27.0516C12.9801 27.0516 12.5598 27.0381 11.1583 26.9741C9.86236 26.915 9.15855 26.6985 8.69017 26.5164C8.06972 26.2753 7.62693 25.9873 7.16182 25.5221C6.69671 25.057 6.40862 24.6142 6.16749 23.9938C5.98545 23.5254 5.76891 22.8216 5.70982 21.5256C5.64587 20.124 5.63231 19.7036 5.63231 16.1544C5.63231 12.6052 5.64587 12.1848 5.70982 10.7832C5.76891 9.4872 5.98545 8.78339 6.16749 8.31501C6.40862 7.69456 6.69665 7.25177 7.16182 6.78666C7.62693 6.32149 8.06972 6.03346 8.69017 5.79233C9.15855 5.61029 9.86236 5.39375 11.1583 5.33466C12.56 5.27071 12.9804 5.25715 16.5296 5.25715ZM16.5299 20.5883C14.0828 20.5883 12.0991 18.6046 12.0991 16.1576C12.0991 13.7105 14.0828 11.7268 16.5299 11.7268C18.9769 11.7268 20.9606 13.7105 20.9606 16.1576C20.9606 18.6046 18.9769 20.5883 16.5299 20.5883ZM16.5288 9.3305C12.759 9.3305 9.70305 12.3865 9.70305 16.1563C9.70305 19.926 12.759 22.982 16.5288 22.982C20.2986 22.982 23.3545 19.926 23.3545 16.1563C23.3545 12.3865 20.2986 9.3305 16.5288 9.3305ZM23.6247 10.6541C24.5056 10.6541 25.2198 9.94005 25.2198 9.05911C25.2198 8.17817 24.5056 7.46401 23.6247 7.46401C22.7438 7.46401 22.0296 8.17817 22.0296 9.05911C22.0296 9.94005 22.7438 10.6541 23.6247 10.6541Z"
          fill="white"
        />
      </g>
    </svg>
  );
};
export const Twitter = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.0133 11.0626L25.8485 0.0532227H23.5176L14.978 9.61229L8.15716 0.0532227H0.290039L10.6045 14.5084L0.290039 26.0532H2.6209L11.6393 15.9585L18.8424 26.0532H26.7095L16.0127 11.0626H16.0133ZM12.821 14.6356L11.7758 13.1962L3.46064 1.74282H7.04067L13.7508 10.9862L14.7958 12.4256L23.5187 24.4404H19.9391L12.821 14.6362V14.6356Z"
        fill="white"
      />
    </svg>
  );
};
export const Telegram = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="la:telegram" clipPath="url(#clip0_570_1040)">
        <path
          id="Vector"
          d="M30.1592 2.25496C29.7887 2.28191 29.4251 2.36884 29.0824 2.51234H29.0778C28.7489 2.64276 27.185 3.30063 24.8074 4.29783L16.2873 7.88613C10.1737 10.4599 4.16397 12.9945 4.16397 12.9945L4.23553 12.9668C4.23553 12.9668 3.82119 13.103 3.38837 13.3996C3.12099 13.5697 2.8909 13.7924 2.71203 14.054C2.49967 14.3656 2.32885 14.8423 2.39233 15.3351C2.4962 16.1684 3.03635 16.6682 3.42415 16.944C3.81657 17.2233 4.19052 17.3538 4.19052 17.3538H4.19975L9.83555 19.2524C10.0883 20.0637 11.5529 24.8789 11.905 25.9881C12.1127 26.6506 12.3147 27.0649 12.5675 27.3811C12.6898 27.5427 12.8329 27.6778 13.0049 27.7863C13.0943 27.8383 13.1896 27.8793 13.2888 27.9086L13.2311 27.8947C13.2484 27.8994 13.2623 27.9132 13.275 27.9178C13.3211 27.9305 13.3523 27.9351 13.4111 27.9444C14.3033 28.2145 15.0201 27.6604 15.0201 27.6604L15.0605 27.6281L18.3879 24.5984L23.9648 28.8769L24.0918 28.9312C25.254 29.4413 26.4313 29.1574 27.0534 28.6565C27.6801 28.1521 27.9236 27.5069 27.9236 27.5069L27.964 27.4031L32.2737 5.32504C32.396 4.78027 32.4272 4.27013 32.2921 3.77499C32.1529 3.27388 31.8314 2.8429 31.3907 2.56658C31.0207 2.34165 30.5917 2.23308 30.1592 2.25496ZM30.0427 4.621C30.0381 4.69371 30.0519 4.68563 30.0196 4.82528V4.83798L25.7503 26.6863C25.7319 26.7175 25.7007 26.7856 25.6153 26.8537C25.5253 26.9252 25.4537 26.9703 25.0786 26.8214L18.2575 21.5918L14.1371 25.3475L15.0027 19.819L26.1474 9.43156C26.6067 9.00452 26.4532 8.91449 26.4532 8.91449C26.4855 8.3905 25.7596 8.76099 25.7596 8.76099L11.7064 17.4669L11.7018 17.4438L4.96612 15.1758V15.1712L4.94881 15.1678C4.96061 15.1638 4.97218 15.1592 4.98343 15.1539L5.02037 15.1354L5.05614 15.1227C5.05614 15.1227 11.0705 12.5882 17.1841 10.0144C20.245 8.72521 23.3289 7.42677 25.7007 6.42496C27.1073 5.83287 28.5154 5.24425 29.925 4.65908C30.0196 4.62215 29.9746 4.621 30.0427 4.621Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_570_1040">
          <rect
            width="31.9013"
            height="31.9013"
            fill="white"
            transform="translate(0.478516 0.106445)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};